import request from '@/utils/request'
import { RecordStatus } from './types'

// 定义接口类型
interface ListOrgParams {
  pageNum?: number
  pageSize?: number
  status?: RecordStatus[]
  keywords?: string[]
}

interface CreateOrgParams {
  name: string
}

interface UpdateOrgNameParams {
  id: number
  orgName: string
}

interface IdParam {
  id: number
}

interface UpdateUserPasswordParams {
  id: number
  password: string
}

interface AddUserParams {
  username: string
  password: string
  phone?: string
}

interface ListUserParams {
  pageNum?: number
  pageSize?: number
  keywords?: string[]
}

interface AddUsersToOrgParams {
  userIds: number[]
  orgId: number
}

// 获取租户列表
export function ListOrg(params?: ListOrgParams) {
  return request({
    url: '/super-admin/orgs',
    method: 'get',
    params
  })
}

// 创建租户
export function CreateOrg(params: CreateOrgParams) {
  return request({
    url: '/super-admin/org',
    method: 'post',
    data: {
      name: params.name
    }
  })
}

// 更新租户名称
export function UpdateOrgName(params: UpdateOrgNameParams) {
  return request({
    url: `/super-admin/org/${params.id}`,
    method: 'post',
    data: {
      name: params.orgName
    }
  })
}

// 启用租户
export function EnableOrg(params: IdParam) {
  return request({
    url: `/super-admin/enable/org/${params.id}`,
    method: 'post'
  })
}

// 禁用租户
export function DisableOrg(params: IdParam) {
  return request({
    url: `/super-admin/disable/org/${params.id}`,
    method: 'post'
  })
}

// 修改用户密码
export function UpdateUserPassword(params: UpdateUserPasswordParams){
  return request({
    url: `/super-admin/password/${params.id}`,
    method: 'post',
    data: {
      password: params.password
    }
  })
}

// 添加用户
export function AddUser(params: AddUserParams) {
  return request({
    url: `/super-admin/user`,
    method: 'post',
    data: {
      username: params.username,
      password: params.password,
      phone: params.phone
    }
  })
}

// 获取用户列表
export function ListUser(params: ListUserParams) {
  return request({
    url: `/super-admin/users`,
    method: 'get',
    params
  })
}

// 启用用户
export function EnableUser(params: IdParam) {
  return request({
    url: `/super-admin/enable/user/${params.id}`,
    method: 'post'
  })
}
// 禁用用户
export function DisableUser(params: IdParam) {
  return request({
    url: `/super-admin/disable/user/${params.id}`,
    method: 'post'
  })
}

// 将用户加入租户
export function AddUsersToOrg(params: AddUsersToOrgParams) {
  return request({
    url: `/super-admin/add_to_org`,
    method: 'post',
    data: {
      userIds: params.userIds,
      orgId: params.orgId
    }
  })
}
